// material-ui
import { Link, Typography, Stack } from '@mui/material';

// ==============================|| FOOTER - AUTHENTICATION 2 & 3 ||============================== //

const AuthFooter = () => (
    <Stack direction="row" justifyContent="space-between">
        <Typography variant="subtitle2" underline="hover">
            MedicalHealth - Sistema de Gestión Médica Dental
        </Typography>
        <Typography variant="subtitle2" component={Link} href="https://github.com/MedicalHealt-devs" target="_blank" underline="hover">
            &copy; Nexvent
        </Typography>
    </Stack>
);

export default AuthFooter;
